<template>
  <div>
    <!-- <PageHead title="创建人员主送组"></PageHead> -->
    <PageHead title="人员主送管理"></PageHead>
    <div class="oa-layout-content">
      <div class="search-flex">
        <div class="search-flex-item mr20">
          <!-- <span>类型：</span>
          <a-select
            allowClear
            placeholder="不限"
            class="w200"
            v-model="queryForm.type"
          >
            <a-select-option :value="1">主送</a-select-option>
            <a-select-option :value="2">抄送</a-select-option>
          </a-select> -->
          <span>主送至人员组：</span>
          <a-input
            class="w300"
            placeholder="请输入主送至人员组"
            v-model="queryForm.groupName"
          />
        </div>
        <div class="search-flex-item">
          <a-button type="primary" @click="subMit" :loading="loading">
            查询</a-button
          >
          <a-button :style="{ marginLeft: '8px' }" @click="cancel">
            取消
          </a-button>
        </div>
      </div>
      <div class="mt20 mb20">
        <a-button type="primary" @click="add()" icon="plus"> 新建</a-button>
      </div>
      <a-table
        :pagination="false"
        :columns="columns"
        :data-source="groupList"
        rowKey="id"
        :loading="loading"
      >
        <span slot="index" slot-scope="text, record, index">
          {{ index + 1 + (page - 1) * 10 }}
        </span>
        <!-- <span slot="type" slot-scope="text">
          {{ text == 1 ? "主送" : "抄送" }}
        </span> -->
        <div slot="action" slot-scope="text, record">
          <a-button type="link" class="btn-link" @click="add(record)">
            编辑
          </a-button>
          <a-divider type="vertical" />
          <a-button
            type="link"
            class="btn-link"
            @click="showDeleteConfirm(record.id)"
          >
            删除
          </a-button>
        </div>
      </a-table>
      <div class="pagination">
        <a-pagination v-model="page" :total="total" @change="pageChange" />
      </div>
    </div>
    <appfloor></appfloor>
    <a-modal
      v-model="visible"
      title="通知配置"
      @ok="handleOk"
      @cancel="handleCancel"
      :width="800"
    >
      <div class="role-formCont">
        <span class="w100 rightAlgin">姓名：</span>
        <a-input
          class="w300 ml20"
          placeholder="请输入姓名"
          v-model="searchName"
        />
        <a-button
          class="ml20"
          type="primary"
          @click="searchNamesubMit"
          :loading="loading"
        >
          查询</a-button
        >
      </div>
      <blank height="20"> </blank>

      <div class="role-formCont">
        <span class="w100 rightAlgin">主送至人员组:</span>
        <a-input
          class="w300 ml20"
          placeholder="请输入主送至人员组"
          v-model="addForm.groupName"
        />
      </div>
      <blank height="20"> </blank>
      <div class="role-formCont">
        <span class="w100 rightAlgin">说明:</span>
        <a-textarea
          class="w300 ml20"
          placeholder="请输入说明"
          v-model="addForm.groupExplain"
          :rows="2"
        />
      </div>
      <blank height="20"> </blank>
      <div class="role-formCont">
        <span class="w100 rightAlgin">组织机构:</span>
        <a-tree-select
          class="w300 ml20"
          :getPopupContainer="triggerNode => triggerNode.parentNode"
          tree-node-filter-prop="title"
          show-search
          v-model="organizationId"
          :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
          :tree-data="treeDataList"
          placeholder="请选择"
          tree-default-expand-all
          :replaceFields="{
                    children: 'treeList',
                    title: 'organizationName',
                    key: 'id',
                    value: 'id'
                  }"
          @change="getUserDataFn"
        >
        </a-tree-select>
      </div>
      <blank height="20"> </blank>
      <div class="role-scrollY">
        <aTableScroll
          ref="tableRef"
          :tableLoading="getListFning"
          :tableData="userData"
          :tableColumns="userColumns"
          :rowSelection="true"
          :rowSelectionKeys.sync="selectedRowKeys"
          :current="pageNum"
          :default-current="pageNum"
          :total="tableTotal"
          :pageSize="pageSize"
          @getListPage="tablePageChange"
          :pageSizeOptions="pageSizeOptions"
          @getShowPageNum="onShowSizeChange"
        >
        </aTableScroll>
        <div class="pagination">
          <a-pagination
            show-size-changer
            v-model="pageNum"
            :pageSizeOptions="pageSizeOptions"
            @showSizeChange="onShowSizeChange"
            :current="pageNum"
            :default-current="pageNum"
            :total="tableTotal"
            :pageSize="pageSize"
            @change="tablePageChange"
            show-quick-jumper
          />
        </div>
      </div>
    </a-modal>
  </div>
</template>
<script>
const columns = [
  {
    title: "序号",
    dataIndex: "index",
    key: "index",
    width: 80,
    align: "center",
    scopedSlots: { customRender: "index" }
  },
  // {
  //   title: "类型",
  //   dataIndex: "type",
  //   key: "type",
  //   scopedSlots: { customRender: "type" },
  //   ellipsis: true,
  //   align: "left",
  // },
  {
    title: "主送至人员组",
    dataIndex: "groupName",
    key: "groupName",
    ellipsis: true,
    align: "left"
  },
  {
    title: "说明",
    dataIndex: "groupExplain",
    key: "groupExplain",
    ellipsis: true,
    align: "left"
  },

  {
    key: "operation",
    scopedSlots: { customRender: "action" },
    title: "操作",
    align: "left",
    width: 120
  }
];
const userColumns = [
  {
    title: "序号",
    dataIndex: "id",
    key: "id",
    width: 160,
    align: "center",
    scopedSlots: { customRender: "index" }
  },
  {
    title: "姓名",
    dataIndex: "fullName",
    key: "fullName",
    width: 200,
    ellipsis: true,
    align: "center"
  },
  {
    title: "电话",
    dataIndex: "phoneNumber",
    key: "phoneNumber",
    ellipsis: true,
    width: 200,
    align: "center"
  },
];
import {
  getSendList,
  addSend,
  updateSend,
  delSend,
  getTreeList, getNewUser
} from "./api/api";
import aTableScroll from "../../components/a-table-scroll/index.vue"
export default {
  components:{aTableScroll},
  data() {
    return {
      userData:[],
      userColumns,
      getListFning: false,
      organizationId:null,
      treeDataList:[],
      selectedRowKeys: [],
      selectedRows:[],
      expandedRowKeys: [],
      visible: false,
      queryForm: {},
      addForm: {
        groupName: "",
        groupExplain: "",
        orgIds: []
      },
      searchName: "",
      page: 1,
      size: 10,
      total: 0, //总条数
      pageNum: 1,
      pageSize: 10,
      tableTotal: 0, //总条数
      pageSizeOptions:['10','50','100','300','500','1000'],
      groupList: [], //列表
      columns,
      loading: false,
      treeData: [], // 组织机构菜单列表
      isSelectAll: true,
    };
  },
  created() {
    this.load();
    this.getTreeListFn()
  },
  methods: {
    onShowSizeChange(page,size){
      this.pageNum = page;
      this.pageSize = size;
      this.onChange(this.organizationId);
    },
    getTreeListFn(){
      getTreeList().then((res) => {
        this.treeDataList = res.data.data
        this.organizationId = res.data.data[0].id
      })
    },
    getUserDataFn(id){
      this.pageNum = 1;
      this.pageSize = 10;
      this.onChange(id)
    },
    onChange(value) {
      this.getListFning = true;
      this.organizationId = value;
      let data = {
        page: this.pageNum,
        size: this.pageSize,
        organizationId: this.organizationId,
        fullName: this.searchName
      };
      // TODO: 需要更换接口
      getNewUser(data).then((res) => {
        this.getListFning = false;
        this.userData = res.data.data;
        this.tableTotal = res.data.count;
      });
    },
    load() {
      this.loading = true;
      let params = this.queryForm;
      params.page = this.page;
      params.size = this.size;
      getSendList(params).then(res => {
        this.loading = false;
        if (res.data.code == 0) {
          this.groupList = res.data.data;
          this.total = res.data.count;
        }
      });
    },
    showDeleteConfirm(id) {
      this.$confirm({
        title: "确定删除吗?",
        okType: "danger",
        onOk: () => {
          delSend({ id }).then(res => {
            if (res.data.code == 0) {
              this.$message.success("删除成功");
              this.load();
            }
          });
        }
      });
    },
    handleOk() {
      // 确认修改/添加
      this.addForm.orgIds = this.selectedRowKeys
      if (this.addForm.id) {
        updateSend(this.addForm).then(res => {
          if (res.data.code == 0) {
            this.$message.success("操作成功");
            this.load();
            this.searchName = "";
            this.visible = false;
          }
        });
      } else {
        addSend(this.addForm).then(res => {
          if (res.data.code == 0) {
            this.$message.success("添加成功");
            this.load();
            this.searchName = "";
            this.visible = false;
          }
        });
      }
      this.getTreeListFn();
    },
    handleCancel() {
      this.searchName = "";
      this.pageNum = 1
      this.pageSize = 10;
      this.visible = false;
      this.userData = [];
      this.tableTotal = 0;
      this.selectedRowKeys = [];
      this.addForm.orgIds = [];
      this.getTreeListFn();
    },
    add(addForm) {
      this.isSelectAll = true;
      this.pageNum = 1;
      this.getTreeListFn();
      this.onChange(this.organizationId)
      if (addForm) {
        this.addForm = { ...addForm };
        this.addForm.orgIds.forEach(item => {
          this.selectedRowKeys.push(Number(item))
        })
      } else {
        this.addForm = { groupName: "", groupExplain: "", orgIds: [] };
        this.selectedRowKeys = [];
      }
      this.visible = true;
    },
    pageChange(pageNumber) {
      this.page = pageNumber;
      this.load();
    },
    tablePageChange(page,size){
      this.pageNum = page;
      this.pageSize = size
      this.onChange(this.organizationId);
    },
    cancel() {
      //取消
      this.queryForm = {};
    },
    subMit() {
      //搜索
      this.page = 1;
      this.load();
    },
    searchNamesubMit() {
      if (this.searchName == "") {
        this.isSelectAll = true;
      } else {
        this.isSelectAll = false;
      }
      this.onChange(this.organizationId, this.searchName);
    }
  }
};
</script>
<style lang="scss" scoped>
.search-flex {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
  .search-flex-item {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
}

.statusDiv {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.role-scrollY {
  overflow-y: scroll;
  max-height: calc(100vh - 500px);
}
// .role-scrollY::-webkit-scrollbar {
//   display: none;
// }
.role-formCont {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  margin-bottom: 10px;
  .role-formlabel {
    width: 120px;
    text-align: right;
    margin-right: 20px;
  }
  .role-formvalue {
    width: calc(100% - 120px);
  }
  .ant-checkbox-wrapper + .ant-checkbox-wrapper {
    margin-left: 0;
    margin-bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/system/InformManagement.vue